import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import GroceryProductList from "../../pages/grocery/pg-grocery-product-list";
import GroceryCategory from "../../pages/grocery/pg-grocery-category";
import GroceryProduct from "../../pages/grocery/pg-grocery-product";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import Footer from "../../components/footer-tab/fixedfooter";

export function RTGroceryCategory(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <GroceryCategory navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTGroceryProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <GroceryProduct navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTGroceryProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <GroceryProductList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
